/**
 * Etichetta visualizzata per tag email (sistema vs custom).
 */
export function getEmailTagDisplayName(tag, t) {
  if (!tag) {
    return '';
  }

  if (tag.is_system) {
    const slug = String(tag.slug || '').toLowerCase();
    if (slug === 'cliente') {
      return t('gym.email.tags.systemActive');
    }
    if (slug === 'ex-cliente') {
      return t('gym.email.tags.systemInactive');
    }
  }

  return tag.name || '';
}
